import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import sessionReducer from './slices/sessionSlice';
import countryReducer from './countrySlice';

const rootReducer = combineReducers({
  user: userReducer,
  session: sessionReducer,
  country: countryReducer,
});

export default rootReducer; 